import {
  GET_CLUBS,
  GET_CLUBS_SUCCESS,
  GET_CLUB_INFO,
  GET_CLUB_INFO_SUCCESS,
  GET_CLUB_INFO_FAILURE,
  GET_CLUB_OWNER,
  GET_CLUB_OWNER_SUCCESS,
  GET_CLUB_ORGANIZERS,
  GET_CLUB_ORGANIZERS_SUCCESS,
  GET_CLUB_LEAD_INFO,
  GET_CLUB_LEAD_INFO_SUCCESS,
  GET_CLUB_ARCHIVE_INFO,
  GET_CLUB_ARCHIVE_INFO_SUCCESS,
  GET_CLUB_LOCATIONS_SUCCESS,
  UNSET_CLUB_OWNER,
  API_ERROR,
  CLUBS_REFRESHED,
} from "./actionTypes"

const initialState = {
  error: "",
  clubs: [],
  clubInfo: {},
  clubOwner: {},
  clubLeadInfo: {},
  clubArchiveInfo: {},
  clubsLocations: [],
  clubOrganizers: {},
  loading: false,
  // The club profile being opened, and why its read failed ({ status }); a late answer for another club is dropped.
  activeClubProfileId: null,
  profileError: null,
}

const clubs = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLUB_LOCATIONS_SUCCESS:
      state = {
        ...state,
        clubsLocations: action?.data,
      }
      break
    case GET_CLUBS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_CLUBS_SUCCESS:
      state = {
        ...state,
        loading: false,
        clubs: action.payload,
      }
      break
    // A background read replaces the list; the saga drops one that a newer read of the list overtook.
    case CLUBS_REFRESHED:
      state = { ...state, clubs: action.payload }
      break
    case GET_CLUB_INFO:
      state = {
        ...state,
        loading: true,
        activeClubProfileId: action.id,
        profileError: null,
        // Another club opens: the club, owner and organizers held so far are the previous club's. A club read again keeps them.
        ...(action.id !== state.activeClubProfileId && { clubInfo: {}, clubOwner: {}, clubOrganizers: {} }),
      }
      break
    case GET_CLUB_INFO_SUCCESS:
      if (action.profileId && action.profileId !== state.activeClubProfileId) break
      state = {
        ...state,
        loading: false,
        profileError: null,
        clubInfo: action.payload,
      }
      break
    case GET_CLUB_INFO_FAILURE:
      if (action.profileId !== state.activeClubProfileId) break
      state = {
        ...state,
        loading: false,
        profileError: action.payload,
        clubInfo: {},
      }
      break
    case GET_CLUB_OWNER:
      state = {
        ...state,
        loading: false,
      }
      break
    // The owner and organizers of the club being opened: a late answer for the previous club is dropped.
    case GET_CLUB_OWNER_SUCCESS:
      if (action.profileId && action.profileId !== state.activeClubProfileId) break
      state = {
        ...state,
        loading: false,
        clubOwner: action.payload,
      }
      break
    case GET_CLUB_ORGANIZERS:
      state = {
        ...state,
        loading: false,
      }
      break
    case GET_CLUB_ORGANIZERS_SUCCESS:
      if (action.profileId && action.profileId !== state.activeClubProfileId) break
      state = {
        ...state,
        loading: false,
        clubOrganizers: action.payload,
      }
      break
    case GET_CLUB_LEAD_INFO:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_CLUB_LEAD_INFO_SUCCESS:
      state = {
        ...state,
        loading: false,
        clubLeadInfo: action.payload,
      }
      break
    case GET_CLUB_ARCHIVE_INFO:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_CLUB_ARCHIVE_INFO_SUCCESS:
      state = {
        ...state,
        loading: false,
        clubArchiveInfo: action.payload,
      }
      break
    case UNSET_CLUB_OWNER:
      state = {
        ...state,
        clubOwner: {},
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default clubs
